import Phaser from 'phaser';
import { ExpeditionScene } from './scenes/ExpeditionScene';
import { HudScene } from './scenes/HudScene';
import { GAME_WIDTH, GAME_HEIGHT } from './config';
import { Telemetry } from './telemetry';
import { getConsent } from './persistence';
import { Run } from './runState';

Telemetry.init({ consent: getConsent() === true });
Telemetry.log('boot');

// Expose Run for browser-console debugging.
(window as unknown as { Run: typeof Run }).Run = Run;

// HMR: tear down a previous game instance so we don't stack WebGL contexts.
const w = window as unknown as { game?: Phaser.Game };
if (w.game) {
  try { w.game.destroy(true); } catch { /* ignore */ }
  w.game = undefined;
  // Remove any leftover canvas.
  const container = document.getElementById('game-container');
  if (container) container.innerHTML = '';
}

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#0a0a0a',
  pixelArt: true,
  roundPixels: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [ExpeditionScene, HudScene],
});

w.game = game;

// Accept HMR — destroy old instance on each update.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    try { game.destroy(true); } catch { /* ignore */ }
    w.game = undefined;
    const container = document.getElementById('game-container');
    if (container) container.innerHTML = '';
  });
}
